// frontend/admin-portal/src/components/settings/sections/FiberDefaultsSettings.jsx
import React from "react";
import SettingItem from "../items/SettingItem";
import SelectInput from "../items/SelectInput";

const CONNECTORS = ["SC", "LC", "FC", "ST", "E2000", "MPO", "MTP"];
const POLISHES = ["UPC", "APC", "PC"];
const FIBER_MODES = [
  "Single-mode (SM)",
  "Multi-mode (MM)",
  "OM3",
  "OM4",
  "OM5",
];
const PON_TYPES = ["GPON", "EPON", "XGS-PON", "XG-PON", "Combo"];

export default function FiberDefaultsSettings({ values = {}, onChange }) {
  const safeOnChange = typeof onChange === "function" ? onChange : () => {};
  return (
    <div className="fh-settings-list">
      <SettingItem label="Default Connector Type">
        <SelectInput
          value={values["fiber.defaultConnectorType"]}
          onChange={(v) => safeOnChange("fiber.defaultConnectorType", v)}
          options={CONNECTORS.map((c) => ({ value: c, label: c }))}
        />
      </SettingItem>
      <SettingItem label="Default Polish">
        <SelectInput
          value={values["fiber.defaultPolish"]}
          onChange={(v) => safeOnChange("fiber.defaultPolish", v)}
          options={POLISHES.map((c) => ({ value: c, label: c }))}
        />
      </SettingItem>
      <SettingItem label="Default Fiber Mode">
        <SelectInput
          value={values["fiber.defaultFiberMode"]}
          onChange={(v) => safeOnChange("fiber.defaultFiberMode", v)}
          options={FIBER_MODES.map((c) => ({ value: c, label: c }))}
        />
      </SettingItem>
      <SettingItem label="Default PON Type">
        <SelectInput
          value={values["fiber.defaultPonType"]}
          onChange={(v) => safeOnChange("fiber.defaultPonType", v)}
          options={PON_TYPES.map((c) => ({ value: c, label: c }))}
        />
      </SettingItem>
    </div>
  );
}
